import { ComponentSettings, FieldTypes } from "../settings/settings";

const field = {
  userId: {
    type: FieldTypes.value,
    text: {
      de: "users",
      en: "User",
      nl: "User",
    },
  },
  time: {
    type: FieldTypes.timestamp,
    text: { de: "When", en: "When", nl: "When" },
  },
  content: {
    type: FieldTypes.value,
    text: {
      de: "Reason",
      en: "Reason",
      nl: "Reason",
    },
  },
  ipAdress: {
    type: FieldTypes.value,
    text: {
      de: "IP Adress",
      en: "IP Adress",
      nl: "IP Adress",
    },
  },
  userAgent: {
    type: FieldTypes.value,
    text: {
      de: "User Agent",
      en: "User Agent",
      nl: "User Agent",
    },
  },
};

const settings = {
  text: {
    userId: {
      de: "",
      en: "User",
      nl: "User",
    },
    time: {
      de: "When",
      en: "When",
      nl: "When",
    },
    reason: {
      de: "Reason",
      en: "Reason",
      nl: "Reason",
    },
  },
  url: {},
  field,
  list: {
    auditColumns: ["auditLog.userId", "auditLog.time", "auditLog.content"],
  },
  permission: {},
  additionalInfo: {},
};

export const auditLog: ComponentSettings<typeof settings> = settings;
